











































































































































































import { Component, Watch } from 'vue-property-decorator';
import Alert from '@/components/Shared/Alert.vue'
import GiganautVue from '@/components/Shared/GiganautVue';
import ConversationDto from '@/models/Conversations/ConversationDto';
import { MessagingModule } from '@/store/modules/messaging';
import MessageBody from '@/components/Messages/Display/MessageBody.vue';
import WorkerProfileMessagingSummary from '@/components/Workers/WorkerProfileMessagingSummary.vue';
import BookingRoleWorkerMessagingSummary from '@/components/BookingRoleWorkers/BookingRoleWorkerMessagingSummary.vue';
import ConversationStatus from '@/components/Conversations/Display/ConversationStatus.vue';
import ConversationListSearchCriteria from '@/components/Conversations/ConversationListSearchCriteria.vue';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import ConversationTopicDto from '@/models/ConversationTopics/ConversationTopicDto';
import ConversationTopicCountChip from '@/components/ConversationTopics/ConversationTopicCountChip.vue';
import ConversationTopicFirestoreDto from '@/models/ConversationTopics/ConversationTopicFirestoreDto';
import { AppModule } from '@/store/modules/app';
import MessageDto from '@/models/Messages/MessageDto';
import ConversationParticipantDto from '@/models/Conversations/ConversationParticipantDto';
import ConversationParticipant from "@/components/Conversations/Display/ConversationParticipant.vue";
import AssignConversation from '@/components/Conversations/AssignConversation.vue';
import CreateConversationParticipant from '@/components/Conversations/CreateConversationParticipant.vue';
import CreateConversationParticipantRequest from '@/models/Conversations/CreateConversationParticipantRequest';
import ConversationStatusEdit from '@/components/Conversations/ConversationStatusEdit.vue';
import EntityTypeEnum from '@/models/Shared/EntityType';

@Component({
	name: 'AgencyMessaging',
  	components: { Alert, ConversationListSearchCriteria, MessageBody, BookingRoleWorkerMessagingSummary, ConversationParticipant, ConversationStatus, ConversationTopicCountChip, AssignConversation, ConversationStatusEdit, CreateConversationParticipant}
})
export default class extends GiganautVue {

  entityType = EntityTypeEnum;
  newMessage = '';
  myMessages = true;
  page = 1;
	perPage = 8;

  get conversations() {
    return MessagingModule.conversations;
  }

  get pagedConversations() {
		return this.conversations.slice((this.page - 1)* this.perPage, this.page* this.perPage)
	}

  get selectedConversationTopic() {
    return MessagingModule.selectedConversationTopic;
  }

  set selectedConversationTopic(value) {
    MessagingModule.updateSelectedConversationTopic(value);
    MessagingModule.getConversations(1);
    this.page = 1;
  }

  async getConversations() {
    await MessagingModule.getConversations(0);
  }

  async updateConversation(conversation: ConversationDto) {
    await MessagingModule.updateSelectedConversation(conversation);
  }

  get bookingRoleWorkerSummary() {
    return MessagingModule.bookingRoleWorkerSummary;
  }

  get conversationTopics() {
    return MessagingModule.conversationTopics;
  }

  getCountValue(count: number) {
    if (count > 9) {
        return "9+";
    }
    return count.toString();
  
  }

  get showNewConversationBanner() {
    return MessagingModule.showNewConversationBanner;
  }

  get isParticipant() {
    return this.selectedConversation.participantFirebaseUserIds.includes(AppModule.currentUser.uid);
  }

  get selectedConversation() {
      return MessagingModule.selectedConversation;
  }

  get messages() {
      return MessagingModule.messages;
  }

  get loadingConversations() {
		return MessagingModule.loadingConversations;
   }

  get conversationParticipantsFiltered() {
    return MessagingModule.conversationParticipants.filter(item => item.entityType !== EntityTypeEnum.ChatBot);
  }

  get agencyUsers() {
    return MessagingModule.agencyUsers;
  }

  async joinConversation() {
    const request = new CreateConversationParticipantRequest();
    request.entityId = AppModule.userProfile.agencyUserId;
    request.entityType = this.EntityType.AgencyUser;
    await MessagingModule.createConversationParticipant(request);
  }

  getParticipant(message: MessageDto) {
      const participant = MessagingModule.conversationParticipants.find((findParticipant: ConversationParticipantDto) => findParticipant.id === message.firebaseUserId);
      return participant;
  }

  async beforeMount() {

    await MessagingModule.mapUserDefaults();
    //await MessagingModule.getConversationTopics();
    await MessagingModule.getAgencyUsers();
    //We can't do this because the conversation topics get returned off an async event
    //so don't exist when this next line gets called immediately after
    //await MessagingModule.getConversations(1);

   
      //await MessagingModule.updateConversation(this.conversations[0]);
      //await ConversationsModule.updateConversation(ConversationsModule.conversations[0]);
      // const onSubscribe = onSnapshot(q, (updatesSnapshot) => {
      //   updatesSnapshot.forEach((doc) => {
      //     const msg = new MessageDto();
      //     msg.branchId = doc.data().branchId;
      //     msg.deskId = doc.data().deskId;
      //     msg.workerId = doc.data().workerId;
      //     msg.subject = doc.data().subject;
      //     this.conversations.push(msg);
      //   }) 
      // });

    //  const unsubscribe = onSnapshot(q, (snapshot) => {
    //   snapshot.docChanges().forEach((change) => {
    //     if (change.type === "added") {
    //         const msg = new MessageDto();
    //       msg.entityId = change.doc.id;
    //       msg.branchId = change.doc.data().branchId;
    //       msg.deskId = change.doc.data().deskId;
    //       msg.workerId = change.doc.data().workerId;
    //       msg.subject = change.doc.data().subject;
    //       this.conversations.unshift(msg);
    //     }
    //   });
    // });

      // use 'collection()' instead of 'doc()'
      // onSnapshot(collection(db, 'agencies'), (snap) => {

      //   snap.forEach((doc) => {
      //     console.log(doc.id);
      //     this.conversations.push(doc);
      //   })
      // })

        // db.collection("agencies").doc("d41ad718-f03f-4a46-a86c-f6a30a6d7a8f").collection("conversations").get()
        // .then((querySnapshot: any[]) => {
        // querySnapshot.forEach(doc => {
        //   console.log(doc.id, ' => ', doc.data())
        // })
      //});

      // db.collection('deliveryservice').doc('0GKIOX8LHdUpxo0ZQrsY').collection('product')
      // .get().then(querySnapshot => {
      //         querySnapshot.forEach(doc => { 
  }

  async onPageChanged(input: number){
		MessagingModule.updateSelectedConversation(this.pagedConversations[0]);
	}

  async sendMessage() {
    if (this.newMessage.trim() != '') {
      await MessagingModule.sendMessage(this.newMessage);
      this.newMessage = '';
    }
  }

  @Watch('selectedConversationTopic')
  async onSelectedConversationTopicChanged(val: ConversationTopicFirestoreDto, oldVal: ConversationTopicFirestoreDto) {
    if (val != null) {
      await MessagingModule.getConversations(0);      
    }
  }

  @Watch('selectedConversation')
  async onConversationChanged(val: ConversationDto, oldVal: ConversationDto) {
    if (val != null) {
      await MessagingModule.updateSelectedConversation(val);
      await MessagingModule.getWorkerProfile(val.workerId);
      if (val.bookingRoleWorkerId) {
        await MessagingModule.getBookingRoleWorkerSummary(val.id);
      }
    }
  }

  getUserAvatarUrl(avatar: string, entityType: number, entityId: string) {
    return AppModule.currentAgencyContext.storageSharedBaseUrl + "/avatars/" + entityType.toString() + "/" + entityId + "/resized-100/" + avatar;
  }

  async clearMessage(){

  }
      }
